<template>
  <div>
    <AppUpdateBanner v-if="!$route.meta.standalone" />
    <router-view />
  </div>
</template>

<script>
import AppUpdateBanner from '@/components/AppUpdateBanner.vue';

export default {
  name: 'App',
  components: { AppUpdateBanner }
}
</script>
